var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Actor_ } from '../../../../../components/actor/Actor_';
import { BasicOptionCheckState, ChoiceOptionState } from '../../../../../classes/learnware/LearnwareEnums';
import { Aspect_ } from '../../../../../components/actor/Aspect_';
import { AvailablePopover } from '../../../../../components/other/AvailablePopover';
let AbfragerMultipleChoiceOptionRow = class AbfragerMultipleChoiceOptionRow extends React.PureComponent {
    get optionState() {
        return this.props.option.optionUI.choiceOptionUIState;
    }
    get checkState() {
        return this.props.option.optionUI.choiceOptionUICheckState;
    }
    get checkIcon() {
        if (this.checkState === BasicOptionCheckState.Wrong) {
            return 'fas fa-times';
        }
        const circleOrSquare = this.props.option.question.choiceInfo.hasMultipleCorrectOptions ? 'square' : 'circle';
        if (this.checkState === BasicOptionCheckState.Correct) {
            return `fas fa-check-${circleOrSquare}`;
        }
        return `fas fa-${circleOrSquare}`;
    }
    get checkColor() {
        if (this.optionState === ChoiceOptionState.ShouldHaveBeenSelected) {
            return '#3C763D';
        }
        if (this.checkState === BasicOptionCheckState.Correct) {
            return '#9CBF52';
        }
        if (this.checkState === BasicOptionCheckState.Wrong) {
            return '#A94442';
        }
        return 'rgba(153, 153, 153, 0.5)';
    }
    get checkOpacity() {
        if (this.optionState === ChoiceOptionState.ShouldHaveBeenSelected) {
            return 0.3;
        }
        return 1;
    }
    get optionBorder() {
        if ([ChoiceOptionState.ShouldHaveBeenSelected, ChoiceOptionState.CorrectDone].includes(this.optionState)) {
            return '1px solid rgba(165, 201, 86, 0.95)';
        }
        if (this.props.option.isPreselecting) {
            return '1px solid #bbb';
        }
        return '1px solid #ccc';
    }
    get optionBackground() {
        if ([ChoiceOptionState.ShouldHaveBeenSelected, ChoiceOptionState.CorrectDone].includes(this.optionState)) {
            return '#cdea8e';
        }
        if (this.props.option.isPreselecting) {
            return 'linear-gradient(#f6f6f6,#e0e0e0)';
        }
        return 'linear-gradient(#ffffff, #f1f1f1)';
    }
    get optionBoxShadow() {
        if ([ChoiceOptionState.ShouldHaveBeenSelected, ChoiceOptionState.CorrectDone].includes(this.optionState)) {
            return '1px 1px 2px rgba(100, 100, 100, 0.5)';
        }
        return undefined;
    }
    get optionTextShadow() {
        if ([ChoiceOptionState.ShouldHaveBeenSelected, ChoiceOptionState.CorrectDone].includes(this.optionState)) {
            return '0 1px 0 #FFF';
        }
        return undefined;
    }
    render() {
        const { option, children } = this.props;
        const comp = (React.createElement(Actor_, { actor: option, structureTemplate: React.createElement("div", { "data-aspect": "inner", style: {
                    borderRadius: 13,
                    marginBottom: 6,
                    color: '#222',
                    fontWeight: 500,
                    flex: '0 1 auto',
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: 47,
                    border: this.optionBorder,
                    background: this.optionBackground,
                    boxShadow: this.optionBoxShadow,
                    textShadow: this.optionTextShadow,
                } },
                React.createElement("div", { "data-aspect": "checkOuter", style: { flex: '0 1 auto', paddingLeft: 15, paddingRight: 11, display: 'flex', alignItems: 'center' }, onClick: option.optionActions.onCheckSelect },
                    React.createElement("span", { "data-aspect": "checkInner", className: this.checkIcon, style: {
                            color: this.checkColor,
                            opacity: this.checkOpacity,
                            fontSize: 22,
                        } }, "\u00A0")),
                children) }));
        return this.wrapCommentPopover(comp);
    }
    wrapCommentPopover(comp) {
        const option = this.props.option;
        return (React.createElement(AvailablePopover, { placement: "right", content: option.commentAspectToShow && React.createElement(Aspect_, { aspect: option.commentAspectToShow }), visible: !!option.commentAspectToShow }, comp));
    }
};
AbfragerMultipleChoiceOptionRow = __decorate([
    observer
], AbfragerMultipleChoiceOptionRow);
export { AbfragerMultipleChoiceOptionRow };
